import React from 'react';
import './Services.css';

const Services = () => {
  const services = [
    {
      id: 1,
      title: "Khảo sát địa hình",
      description: "Dịch vụ đo đạc và khảo sát địa hình chuyên nghiệp",
      details: [
        "Khảo sát địa hình chi tiết",
        "Đo vẽ hiện trạng công trình",
        "Lập bản đồ địa hình các tỷ lệ",
        "Khảo sát phục vụ thiết kế",
        "Đo đạc ranh giới đất đai"
      ],
      icon: "🗺️"
    },
    {
      id: 2,
      title: "Thiết kế hạ tầng kỹ thuật",
      description: "Thiết kế các hạng mục hạ tầng kỹ thuật theo quy chuẩn",
      details: [
        "Thiết kế đường giao thông",
        "Thiết kế hệ thống cấp nước",
        "Thiết kế hệ thống thoát nước",
        "Thiết kế điện chiếu sáng",
        "Thiết kế hạ tầng kỹ thuật khu đô thị"
      ],
      icon: "🏗️"
    },
    {
      id: 3,
      title: "Tư vấn giám sát",
      description: "Tư vấn và giám sát thi công các công trình xây dựng",
      details: [
        "Tư vấn thiết kế kỹ thuật",
        "Giám sát thi công xây dựng",
        "Nghiệm thu công trình",
        "Tư vấn quản lý dự án",
        "Đánh giá tác động môi trường"
      ],
      icon: "👷"
    },
    {
      id: 4,
      title: "Khảo sát địa chất",
      description: "Khoan khảo sát địa chất công trình chuyên nghiệp",
      details: [
        "Khoan khảo sát địa chất công trình",
        "Thí nghiệm cơ lý đất trong phòng",
        "Thí nghiệm hiện trường SPT & CBR",
        "Khảo sát địa chất nền móng",
        "Báo cáo địa chất chi tiết"
      ],
      icon: "🌍"
    },
    {
      id: 5,
      title: "Dịch vụ thương mại",
      description: "Cung cấp vật liệu và thiết bị xây dựng chất lượng",
      details: [
        "Cung cấp vật liệu xây dựng",
        "Thiết bị đo đạc chuyên dụng",
        "Máy móc thi công",
        "Tư vấn lựa chọn vật liệu",
        "Dịch vụ vận chuyển"
      ],
      icon: "🏪"
    },
    {
      id: 6,
      title: "Lập dự án đầu tư",
      description: "Lập hồ sơ dự án đầu tư xây dựng các công trình",
      details: [
        "Lập báo cáo nghiên cứu khả thi",
        "Thiết kế sơ bộ",
        "Thiết kế kỹ thuật",
        "Thiết kế bản vẽ thi công",
        "Lập dự toán chi phí"
      ],
      icon: "📋"
    },
    {
      id: 7,
      title: "Thiết kế Quy hoạch xây dựng",
      description: "Lập đồ án quy hoạch chi tiết và quy hoạch chung",
      details: [
        "Lập nhiệm vụ quy hoạch",
        "Lập đồ án quy hoạch",
        "Lập điều chỉnh quy hoạch",
        "Lập điều chỉnh quy hoạch rút gọn",
        "Quy hoạch khu đô thị và công nghiệp"
      ],
      icon: "🏙️"
    }
  ];

  return (
    <div className="services-page">
      <div className="container">
        {/* Page Header */}
        <section className="page-header">
          <h1>Dịch vụ của chúng tôi</h1>
          <p>Cung cấp giải pháp toàn diện với trung tâm thí nghiệm LAS-XD27.004 và 102 chỉ tiêu thí nghiệm chuyên ngành</p>
        </section>

        {/* Services Grid */}
        <section className="services-section">
          <div className="services-grid">
            {services.map(service => (
              <div key={service.id} className="service-card">
                <div className="service-icon">{service.icon}</div>
                <h3>{service.title}</h3>
                <p className="service-description">{service.description}</p>
                <ul className="service-details">
                  {service.details.map((detail, index) => (
                    <li key={index}>{detail}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </section>

        {/* Process Section */}
        <section className="process-section">
          <h2>Quy trình làm việc</h2>
          <div className="process-steps">
            <div className="step">
              <div className="step-number">1</div>
              <h4>Tiếp nhận yêu cầu</h4>
              <p>Tư vấn và khảo sát nhu cầu khách hàng</p>
            </div>
            <div className="step">
              <div className="step-number">2</div>
              <h4>Khảo sát thực địa</h4>
              <p>Đo đạc và khảo sát hiện trạng tại hiện trường</p>
            </div>
            <div className="step">
              <div className="step-number">3</div>
              <h4>Thiết kế và báo giá</h4>
              <p>Lập thiết kế và đưa ra báo giá chi tiết</p>
            </div>
            <div className="step">
              <div className="step-number">4</div>
              <h4>Thực hiện dự án</h4>
              <p>Triển khai thực hiện theo tiến độ cam kết</p>
            </div>
            <div className="step">
              <div className="step-number">5</div>
              <h4>Nghiệm thu bàn giao</h4>
              <p>Nghiệm thu và bàn giao sản phẩm cho khách hàng</p>
            </div>
          </div>
        </section>

        {/* Why Choose Us */}
        <section className="why-choose-us">
          <h2>Tại sao chọn DSC.JSC?</h2>
          <div className="advantages-grid">
            <div className="advantage-item">
              <h4>🎯 Chuyên nghiệp</h4>
              <p>Đội ngũ kỹ sư có trình độ cao và kinh nghiệm thực tế phong phú</p>
            </div>
            <div className="advantage-item">
              <h4>⚡ Nhanh chóng</h4>
              <p>Cam kết hoàn thành đúng tiến độ, đáp ứng yêu cầu khẩn cấp</p>
            </div>
            <div className="advantage-item">
              <h4>✅ Chất lượng</h4>
              <p>Tuân thủ nghiêm ngặt các quy chuẩn và tiêu chuẩn kỹ thuật</p>
            </div>
            <div className="advantage-item">
              <h4>💰 Giá cạnh tranh</h4>
              <p>Báo giá minh bạch, chi phí hợp lý phù hợp với ngân sách</p>
            </div>
            <div className="advantage-item">
              <h4>🔧 Trang thiết bị hiện đại</h4>
              <p>Sử dụng máy móc và thiết bị đo đạc tiên tiến nhất</p>
            </div>
            <div className="advantage-item">
              <h4>🤝 Hỗ trợ tận tình</h4>
              <p>Tư vấn và hỗ trợ khách hàng 24/7 trong suốt quá trình thực hiện</p>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="cta-section">
          <div className="cta-content">
            <h2>Bạn cần tư vấn dịch vụ?</h2>
            <p>Liên hệ với chúng tôi để được tư vấn miễn phí và báo giá chi tiết</p>
            <div className="cta-buttons">
              <a href="/contact" className="btn btn-primary">Liên hệ ngay</a>
              <a href="tel:+842253920691" className="btn btn-secondary">Gọi điện tư vấn</a>
            </div>
          </div>
        </section>

        {/* Equipment Section */}
        <section className="equipment-section">
          <div className="equipment-content">
            <h2>Trung tâm Thí nghiệm LAS-XD27.004</h2>
            <p>Trung tâm thí nghiệm vật liệu và khảo sát địa chất được Sở Xây dựng Hải Phòng công nhận với đầy đủ năng lực thí nghiệm</p>
            
            <div className="lab-info">
              <div className="lab-detail">
                <h4>📋 Giấy chứng nhận</h4>
                <p>Số 3335/GCN-SXD ngày 05/07/2024</p>
              </div>
              <div className="lab-detail">
                <h4>🏢 Địa chỉ</h4>
                <p>Lô 258 - dự án An Đồng – Phường An Hải – Thành phố Hải Phòng</p>
              </div>
              <div className="lab-detail">
                <h4>⏰ Hiệu lực</h4>
                <p>5 năm (đến năm 2029)</p>
              </div>
              <div className="lab-detail">
                <h4>🔬 Phạm vi thí nghiệm</h4>
                <p>102 chỉ tiêu thí nghiệm trong 12 nhóm chuyên ngành</p>
              </div>
            </div>
            
            <div className="test-groups">
              <h3>Các nhóm thí nghiệm chuyên ngành (102 chỉ tiêu):</h3>
              <div className="test-groups-grid">
                <div className="test-group">
                  <span className="group-icon">🏗️</span>
                  <span>Xi măng (3 chỉ tiêu)</span>
                </div>
                <div className="test-group">
                  <span className="group-icon">🪨</span>
                  <span>Cốt liệu bê tông & vữa (12 chỉ tiêu)</span>
                </div>
                <div className="test-group">
                  <span className="group-icon">🧱</span>
                  <span>Hỗn hợp bê tông & bê tông nặng (10 chỉ tiêu)</span>
                </div>
                <div className="test-group">
                  <span className="group-icon">🔨</span>
                  <span>Vữa xây dựng (4 chỉ tiêu)</span>
                </div>
                <div className="test-group">
                  <span className="group-icon">🧱</span>
                  <span>Gạch các loại (8 chỉ tiêu)</span>
                </div>
                <div className="test-group">
                  <span className="group-icon">⚙️</span>
                  <span>Kim loại & mối hàn (5 chỉ tiêu)</span>
                </div>
                <div className="test-group">
                  <span className="group-icon">🌍</span>
                  <span>Cơ lý đất trong phòng (16 chỉ tiêu)</span>
                </div>
                <div className="test-group">
                  <span className="group-icon">🪨</span>
                  <span>Cơ lý đá xây dựng (2 chỉ tiêu)</span>
                </div>
                <div className="test-group">
                  <span className="group-icon">🔬</span>
                  <span>Thí nghiệm hiện trường (9 chỉ tiêu)</span>
                </div>
                <div className="test-group">
                  <span className="group-icon">🛣️</span>
                  <span>Nhựa bitum (8 chỉ tiêu)</span>
                </div>
                <div className="test-group">
                  <span className="group-icon">🛤️</span>
                  <span>Bê tông nhựa (20 chỉ tiêu)</span>
                </div>
                <div className="test-group">
                  <span className="group-icon">💧</span>
                  <span>Phân tích hóa nước xây dựng (5 chỉ tiêu)</span>
                </div>
              </div>
            </div>

            <div className="lab-capabilities">
              <h3>Năng lực thí nghiệm chi tiết (102 chỉ tiêu):</h3>
              <div className="capabilities-note">
                <p><strong>Lưu ý:</strong> Dưới đây là danh sách đầy đủ 102 chỉ tiêu thí nghiệm được Trung tâm LAS-XD27.004 thực hiện. Các nhóm chính được trình bày dưới dạng bảng chi tiết bao gồm thông tin về máy móc thiết bị sử dụng.</p>
              </div>
              
              <div className="detailed-capabilities">
                <div className="capability-section">
                  <h4>🏗️ I. Thử cơ lý của Xi măng (3 chỉ tiêu)</h4>
                  <div className="test-table">
                    <div className="test-table-header">
                      <div className="col-number">STT</div>
                      <div className="col-test">Tên chỉ tiêu thí nghiệm</div>
                      <div className="col-standard">Tiêu chuẩn kỹ thuật</div>
                      <div className="col-equipment">Máy móc thiết bị</div>
                    </div>
                    <div className="test-table-row">
                      <div className="col-number">1</div>
                      <div className="col-test">
                        <strong>Xác định độ mịn, khối lượng riêng của xi măng</strong>
                      </div>
                      <div className="col-standard">TCVN 4030:2003; ASTM C184, C188, C204, AASHTO T133, T153, T192</div>
                      <div className="col-equipment">Sàng 0,09 mm, Cân kỹ thuật 0,01g, tủ sấy, bình khối lượng riêng, chậu nước, dầu hoả, thùng đong</div>
                    </div>
                    <div className="test-table-row">
                      <div className="col-number">2</div>
                      <div className="col-test">
                        <strong>Xác định giới hạn bền uốn và nén</strong>
                      </div>
                      <div className="col-standard">TCVN 6016:2011; TCVN 9488:12; ASTM C109; AASHTO T106</div>
                      <div className="col-equipment">Máy trộn, khuôn (4x4x16cm), máy dằn tạo mẫu, máy thử độ bền uốn (10kN±1%), máy thử độ bền nén (tăng tải 2400±200N/s), gá định vị thử uốn, gá thử cường độ nén</div>
                    </div>
                    <div className="test-table-row">
                      <div className="col-number">3</div>
                      <div className="col-test">
                        <strong>Xác định độ dẻo tiêu chuẩn, thời gian đông kết và tính ổn định thể tích</strong>
                      </div>
                      <div className="col-standard">TCVN 6017:2015; ASTM C187, C191, C266, C451; AASHTO T131, T129</div>
                      <div className="col-equipment">Dụng cụ Vica, vành khâu, chảo trộn, bay trộn hồ, cân kỹ thuật (0,01g), ống đong, dao thép, tấm kim loại, đồng hồ bấm giây hoặc đồng hồ cát, cân (1g), máy trộn thùng luộc mẫu, khuôn Lơ Satơlie</div>
                    </div>
                  </div>
                </div>

                <div className="capability-section">
                  <h4>🪨 II. Cốt liệu cho bê tông và vữa (12 chỉ tiêu)</h4>
                  <div className="test-table">
                    <div className="test-table-header">
                      <div className="col-number">STT</div>
                      <div className="col-test">Tên chỉ tiêu thí nghiệm</div>
                      <div className="col-standard">Tiêu chuẩn kỹ thuật</div>
                      <div className="col-equipment">Máy móc thiết bị</div>
                    </div>
                    <div className="test-table-row">
                      <div className="col-number">4</div>
                      <div className="col-test">
                        <strong>Xác định thành phần cỡ hạt, mô đun độ lớn</strong>
                      </div>
                      <div className="col-standard">TCVN 7572-2:06; ASTM C136; AASHTO T27</div>
                      <div className="col-equipment">Cân kỹ thuật độ chính xác 1%; Bộ sàng tiêu chuẩn; Tủ sấy có bộ phận điều chỉnh nhiệt độ đạt nhiệt độ sấy ổn định từ 105°C đến 110°C</div>
                    </div>
                    <div className="test-table-row">
                      <div className="col-number">5</div>
                      <div className="col-test">
                        <strong>Xác định khối lượng riêng, khối lượng thể tích và độ hút nước (cát)</strong>
                      </div>
                      <div className="col-standard">TCVN 7572-4:06; ASTM C127, C128; AASHTO T84</div>
                      <div className="col-equipment">Cân kỹ thuật, độ chính xác 0,1%; Tủ sấy có bộ phận điều chỉnh nhiệt độ sấy ổn định từ 105°C đến 110°C; Bình dung tích, bằng thuỷ tinh, có miệng rộng, nhẵn, phẳng dung tích từ 1,05 lít đến 1,5 lít và có tấm nắp đậy bằng thuỷ tinh, đảm bảo kín khí</div>
                    </div>
                    <div className="test-table-row">
                      <div className="col-number">6</div>
                      <div className="col-test">
                        <strong>Xác định khối lượng riêng, khối lượng thể tích và độ hút nước của đá gốc và cốt liệu lớn</strong>
                      </div>
                      <div className="col-standard">TCVN 7572-5:06; ASTM C127; AASHTO T85</div>
                      <div className="col-equipment">Cân kỹ thuật, có độ chính xác 1%; Cân thủy tĩnh, có độ chính xác 1%, và có giỏ đựng mẫu; Thùng ngâm mẫu, bằng gỗ hay bằng vật liệu không gỉ; Tủ sấy có bộ phận điều chỉnh nhiệt độ sấy ổn định từ 105°C đến 110°C</div>
                    </div>
                    <div className="test-table-row">
                      <div className="col-number">7</div>
                      <div className="col-test">
                        <strong>Xác định khối lượng thể tích, độ xốp và độ hổng</strong>
                      </div>
                      <div className="col-standard">TCVN 7572-6:06; TCVN10322-2014; ASTM C29; AASHTO T19</div>
                      <div className="col-equipment">Thùng đong bằng kim loại, hình trụ, dung tích 1l; 2l; 5l; 10l và 20l; Cân kỹ thuật độ chính xác 1%; Phễu chứa vật liệu; Bộ sàng tiêu chuẩn; Tủ sấy có bộ phận điều chỉnh nhiệt độ đạt nhiệt độ sấy ổn định từ 105°C đến 110°C; Thước lá kim loại</div>
                    </div>
                    <div className="test-table-row">
                      <div className="col-number">8</div>
                      <div className="col-test">
                        <strong>Xác định độ ẩm, độ hút nước</strong>
                      </div>
                      <div className="col-standard">TCVN 7572-7:06; ASTM C566; AASHTO T255</div>
                      <div className="col-equipment">Cân kỹ thuật có độ chính xác tới 1%; Tủ sấy có bộ phận điều chỉnh nhiệt độ đạt nhiệt độ sấy ổn định từ 105°C đến 110°C</div>
                    </div>
                    <div className="test-table-row">
                      <div className="col-number">9</div>
                      <div className="col-test">
                        <strong>Xác định hàm lượng bùn, bụi, sét trong cốt liệu và hàm lượng sét cục trong cốt liệu nhỏ</strong>
                      </div>
                      <div className="col-standard">TCVN 7572-8:06; TCVN 9205:12; ASTM C117, C142; AASHTO T11, T112</div>
                      <div className="col-equipment">Cân kỹ thuật có độ chính xác tới 0,1% và cân kỹ thuật có độ chính xác 1%; Tủ sấy có bộ phận điều chỉnh nhiệt độ sấy ổn định từ 105°C đến 110°C; Thùng rửa cốt liệu; Tấm kính hoặc tấm kim loại phẳng sạch</div>
                    </div>
                    <div className="test-table-row">
                      <div className="col-number">10</div>
                      <div className="col-test">
                        <strong>Xác định tạp chất hữu cơ</strong>
                      </div>
                      <div className="col-standard">TCVN 7572-9:06; ASTM C40; AASHTO T21</div>
                      <div className="col-equipment">Ống dung tích hình trụ bằng thủy tinh, dung tích 250ml; Cân kỹ thuật có độ chính xác 0,1%; Thang màu để so sánh; Thuốc thử: NaOH dung dịch 3%; tananh dung dịch 2%; rượu êtylic dung dịch 1%</div>
                    </div>
                    <div className="test-table-row">
                      <div className="col-number">11</div>
                      <div className="col-test">
                        <strong>Xác định cường độ và hệ số hoá mềm của đá gốc</strong>
                      </div>
                      <div className="col-standard">TCVN 7572-10:2006</div>
                      <div className="col-equipment">Máy nén thủy lực; Máy khoan và máy cưa đá; Thước kẹp; Thùng hoặc chậu để ngâm mẫu</div>
                    </div>
                    <div className="test-table-row">
                      <div className="col-number">12</div>
                      <div className="col-test">
                        <strong>Xác định độ nén dập trong xilanh và hệ số hoá mềm của cốt liệu lớn</strong>
                      </div>
                      <div className="col-standard">TCVN 7572-11:06; ASTM C170, D2938</div>
                      <div className="col-equipment">Máy nén thủy có lực nén đạt 500kN; Xi lanh bằng thép, có đáy rời; Cân kỹ thuật có độ chính xác 1%; Bộ sàng tiêu chuẩn; Tủ sấy có bộ phận điều chỉnh nhiệt độ đạt nhiệt độ sấy ổn định từ 105°C đến 110°C; Thùng ngâm mẫu</div>
                    </div>
                    <div className="test-table-row">
                      <div className="col-number">13</div>
                      <div className="col-test">
                        <strong>Xác định độ hao mòn khi va đập của cốt liệu lớn trong máy Los Angeles</strong>
                      </div>
                      <div className="col-standard">TCVN 7572-12:06; ASTM C131, C535; AASHTO T98, T327</div>
                      <div className="col-equipment">Máy Los Angeles; Bi thép, khối lượng từ mỗi viên từ 390g đến 445g; Cân kỹ thuật độ chính xác 1%; Bộ sàng 1,7mm; Tủ sấy có bộ phận điều chỉnh nhiệt độ sấy ổn định từ 105°C đến 110°C</div>
                    </div>
                    <div className="test-table-row">
                      <div className="col-number">14</div>
                      <div className="col-test">
                        <strong>Xác định hàm lượng hạt thoi dẹt trong cốt liệu lớn</strong>
                      </div>
                      <div className="col-standard">TCVN 7572-13:06; ASTM D4791; AASHTO T335</div>
                      <div className="col-equipment">Cân kỹ thuật độ chính xác tới 1%; Thước kẹp cải tiến; Bộ sàng tiêu chuẩn; Tủ sấy có bộ phận điều chỉnh nhiệt độ đạt nhiệt độ sấy ổn định từ 105°C đến 110°C</div>
                    </div>
                    <div className="test-table-row">
                      <div className="col-number">15</div>
                      <div className="col-test">
                        <strong>Xác định hàm lượng hạt mềm yếu và phong hóa trong đá dăm (sỏi)</strong>
                      </div>
                      <div className="col-standard">TCVN 7572-17:06; ASTM C142; AASHTO T112</div>
                      <div className="col-equipment">Cân kỹ thuật độ chính xác 0,01g; Tủ sấy điều chỉnh nhiệt độ; Bộ sàng tiêu chuẩn; Kim sắt, kim nhôm</div>
                    </div>
                  </div>
                </div>

                <div className="capability-section">
                  <h4>🧱 III. Hỗn hợp bê tông và bê tông nặng (10 chỉ tiêu)</h4>
                  <div className="test-table">
                    <div className="test-table-header">
                      <div className="col-number">STT</div>
                      <div className="col-test">Tên chỉ tiêu thí nghiệm</div>
                      <div className="col-standard">Tiêu chuẩn kỹ thuật</div>
                      <div className="col-equipment">Máy móc thiết bị</div>
                    </div>
                    <div className="test-table-row">
                      <div className="col-number">16</div>
                      <div className="col-test">
                        <strong>Lấy mẫu, chế tạo, bảo dưỡng mẫu bê tông</strong>
                      </div>
                      <div className="col-standard">TCVN 3105:2022; ASTM C31, AASHTO T23</div>
                      <div className="col-equipment">Bộ khuôn lấy mẫu lập phương, hình trụ; Que chọc; Bay, xẻng...</div>
                    </div>
                    <div className="test-table-row">
                      <div className="col-number">17</div>
                      <div className="col-test">
                        <strong>Xác định độ sụt của hỗn hợp bê tông</strong>
                      </div>
                      <div className="col-standard">TCVN 3106:2022; ASTM C143, AASHTO T119</div>
                      <div className="col-equipment">Côn thử độ sụt; Que chọc; Phễu đổ hỗn hợp; Thước lá kim loại dài 80cm chính xác tới 0,5cm</div>
                    </div>
                    <div className="test-table-row">
                      <div className="col-number">18</div>
                      <div className="col-test">
                        <strong>Xác định khối lượng thể tích hỗn hợp bê tông</strong>
                      </div>
                      <div className="col-standard">TCVN 3108:2022; ASTM C138; AASHTO T121</div>
                      <div className="col-equipment">Cân kỹ thuật (50g); Thước lá kim loại; Cân thuỷ tĩnh có độ chính xác tới 50g; Bếp điện; Thùng nấu paraphin; Tủ sấy 200°C</div>
                    </div>
                    <div className="test-table-row">
                      <div className="col-number">19</div>
                      <div className="col-test">
                        <strong>Xác định độ tách nước và tách vữa</strong>
                      </div>
                      <div className="col-standard">TCVN 3109:2022; ASTM C232; AASHTO T158</div>
                      <div className="col-equipment">Khuôn thép kích thước 200x200x200mm; Bàn rung; Cân kĩ thuật có độ chính xác tới 0.1%; Sàng, Pipet...</div>
                    </div>
                    <div className="test-table-row">
                      <div className="col-number">20</div>
                      <div className="col-test">
                        <strong>Xác định khối lượng riêng và độ rỗng</strong>
                      </div>
                      <div className="col-standard">TCVN 3112:2022; ASTM C642</div>
                      <div className="col-equipment">Bình khối lượng riêng; Cân điện tử chính xác 0,01g; Tủ sấy; Bếp cách cát; Sàng...</div>
                    </div>
                    <div className="test-table-row">
                      <div className="col-number">21</div>
                      <div className="col-test">
                        <strong>Xác định độ hút nước</strong>
                      </div>
                      <div className="col-standard">TCVN 3113:2022; ASTM C642; ASTM C1585</div>
                      <div className="col-equipment">Cân kỹ thuật chính xác (5g); Thùng ngâm mẫu; Tủ sấy...</div>
                    </div>
                    <div className="test-table-row">
                      <div className="col-number">22</div>
                      <div className="col-test">
                        <strong>Xác định khối lượng thể tích bê tông</strong>
                      </div>
                      <div className="col-standard">TCVN 3115:2022; ASTM C138, C642; AASHTO T121</div>
                      <div className="col-equipment">Cân kỹ thuật; Thước lá kim loại; Tủ sấy</div>
                    </div>
                    <div className="test-table-row">
                      <div className="col-number">23</div>
                      <div className="col-test">
                        <strong>Xác định cường độ chịu nén</strong>
                      </div>
                      <div className="col-standard">TCVN 3118:2022; ASTM C39, C42; AASHTO T22, T140, T42</div>
                      <div className="col-equipment">Máy nén 1000kN-2000kN; Thước lá kim loại; Đệm truyền tải</div>
                    </div>
                    <div className="test-table-row">
                      <div className="col-number">24</div>
                      <div className="col-test">
                        <strong>Xác định cường độ bê tông trên mẫu lấy từ kết cấu (rút lõi)</strong>
                      </div>
                      <div className="col-standard">TCVN 12252:2020; ASTM C42:1990</div>
                      <div className="col-equipment">Máy nén bê tông; Máy khoan rút lõi</div>
                    </div>
                    <div className="test-table-row">
                      <div className="col-number">25</div>
                      <div className="col-test">
                        <strong>Xác định nhiệt độ hỗn hợp bê tông</strong>
                      </div>
                      <div className="col-standard">ASTM C1064; AASHTO T309</div>
                      <div className="col-equipment">Nhiệt kế, đồng hồ</div>
                    </div>
                  </div>
                </div>

                <div className="capability-section">
                  <h4>🔨 IV. Vữa xây dựng (4 chỉ tiêu)</h4>
                  <div className="test-list">
                    <div className="test-item">
                      <span className="test-number">26.</span>
                      <div className="test-details">
                        <strong>Xác định độ lưu động của vữa tươi (phương pháp bàn dằn)</strong>
                        <p>Tiêu chuẩn: TCVN 3121-3:2022</p>
                      </div>
                    </div>
                    <div className="test-item">
                      <span className="test-number">27.</span>
                      <div className="test-details">
                        <strong>Xác định khối lượng thể tích của vữa tươi</strong>
                        <p>Tiêu chuẩn: TCVN 3121-6:2022</p>
                      </div>
                    </div>
                    <div className="test-item">
                      <span className="test-number">28.</span>
                      <div className="test-details">
                        <strong>Xác định cường độ uốn và nén của vữa đã đóng rắn</strong>
                        <p>Tiêu chuẩn: TCVN 3121-11:2022</p>
                      </div>
                    </div>
                    <div className="test-item">
                      <span className="test-number">29.</span>
                      <div className="test-details">
                        <strong>Xác định độ hút nước của vữa đã đóng rắn</strong>
                        <p>Tiêu chuẩn: TCVN 3121-18:2022</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="capability-section">
                  <h4>🧱 V. Gạch (8 chỉ tiêu)</h4>
                  <div className="test-list">
                    <div className="test-item">
                      <span className="test-number">30.</span>
                      <div className="test-details">
                        <strong>Gạch bê tông: Kiểm tra kích thước hình học, khuyết tật ngoại quan; cường độ nén; độ hút nước; độ thấm nước; độ rỗng</strong>
                        <p>Tiêu chuẩn: TCVN 6477:2016</p>
                      </div>
                    </div>
                    <div className="test-item">
                      <span className="test-number">31.</span>
                      <div className="test-details">
                        <strong>Gạch xây đất sét nung: Kiểm tra kích thước, khuyết tật ngoại quan; cường độ nén; cường độ uốn; độ hút nước; khối lượng thể tích; khối lượng riêng, xác định độ rỗng; xác định sự thoát muối</strong>
                        <p>Tiêu chuẩn: TCVN 6355:2009</p>
                      </div>
                    </div>
                    <div className="test-item">
                      <span className="test-number">32.</span>
                      <div className="test-details">
                        <strong>Gạch bê tông tự chèn: Kiểm tra kích thước và mức khuyết tật ngoại quan; xác định cường độ nén; xác định độ hút nước; xác định độ chịu mài mòn</strong>
                        <p>Tiêu chuẩn: TCVN 6477:2016</p>
                      </div>
                    </div>
                    <div className="test-item">
                      <span className="test-number">33.</span>
                      <div className="test-details">
                        <strong>Gạch lát xi măng: Kiểm tra kích thước và mức khuyết tật ngoại quan; xác định cường độ nén; xác định độ hút nước; xác định độ chịu mài mòn</strong>
                        <p>Tiêu chuẩn: TCVN 6065:1995</p>
                      </div>
                    </div>
                    <div className="test-item">
                      <span className="test-number">34.</span>
                      <div className="test-details">
                        <strong>Gạch lát Granito: Kiểm tra kích thước và khuyết tật ngoại quan; xác định độ mài mòn; xác định độ chịu va đập xung kích; xác định độ cứng lớp mặt</strong>
                        <p>Tiêu chuẩn: TCVN 6076:1995</p>
                      </div>
                    </div>
                    <div className="test-item">
                      <span className="test-number">35.</span>
                      <div className="test-details">
                        <strong>Gạch gốm ốp, lát: kiểm tra kích thước, hình dạng và chất lượng bề mặt; Độ hút nước: Độ bền uốn; Độ chịu mài mòn</strong>
                        <p>Tiêu chuẩn: TCVN 6415:2016</p>
                      </div>
                    </div>
                    <div className="test-item">
                      <span className="test-number">36.</span>
                      <div className="test-details">
                        <strong>Đá ốp lát tự nhiên; kiểm tra kích thước, hình dạng và chất lượng bề mặt; Độ hút nước: Độ bền uốn; Độ chịu mài mòn</strong>
                        <p>Tiêu chuẩn: TCVN 4732:2016; TCVN 6415:2016</p>
                      </div>
                    </div>
                    <div className="test-item">
                      <span className="test-number">37.</span>
                      <div className="test-details">
                        <strong>Đá ốp lát nhân tạo: kiểm tra kích thước, hình dạng và chất lượng bề mặt; Độ hút nước: Độ bền uốn; Độ chịu mài mòn</strong>
                        <p>Tiêu chuẩn: TCVN 8057:2009; TCVN 6415:2016</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="capability-section">
                  <h4>⚙️ VI. Kim loại và mối hàn (5 chỉ tiêu)</h4>
                  <div className="test-list">
                    <div className="test-item">
                      <span className="test-number">38.</span>
                      <div className="test-details">
                        <strong>Thử kéo</strong>
                        <p>Tiêu chuẩn: TCVN 197:2014 (ISO 6892:2009); ASTM A370</p>
                      </div>
                    </div>
                    <div className="test-item">
                      <span className="test-number">39.</span>
                      <div className="test-details">
                        <strong>Thử uốn</strong>
                        <p>Tiêu chuẩn: TCVN 198:2008 (ISO 7438:2005); TCVN 6287:1997</p>
                      </div>
                    </div>
                    <div className="test-item">
                      <span className="test-number">40.</span>
                      <div className="test-details">
                        <strong>Kiểm tra chất lượng mối hàn ống - Thử nén bẹp</strong>
                        <p>Tiêu chuẩn: TCVN 1830:2008</p>
                      </div>
                    </div>
                    <div className="test-item">
                      <span className="test-number">41.</span>
                      <div className="test-details">
                        <strong>Kiểm tra chất lượng mối hàn - Thử uốn</strong>
                        <p>Tiêu chuẩn: TCVN 5401:2010</p>
                      </div>
                    </div>
                    <div className="test-item">
                      <span className="test-number">42.</span>
                      <div className="test-details">
                        <strong>Thử kéo mối hàn kim loại</strong>
                        <p>Tiêu chuẩn: TCVN 5403:1991</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="detailed-capabilities-part2">
                <div className="capability-section">
                  <h4>🌍 VII. Thử nghiệm Cơ lý của đất trong phòng (16 chỉ tiêu)</h4>
                  <div className="test-list">
                    <div className="test-item">
                      <span className="test-number">43.</span>
                      <div className="test-details">
                        <strong>Lấy mẫu, chuẩn bị mẫu</strong>
                        <p>Tiêu chuẩn: TCVN 2683:2012; TCVN 14134-1:2024; TCVN 14134-2:2024</p>
                      </div>
                    </div>
                    <div className="test-item">
                      <span className="test-number">44.</span>
                      <div className="test-details">
                        <strong>Xác định khối lượng riêng (tỷ trọng)</strong>
                        <p>Tiêu chuẩn: TCVN 4195:2012; AASHTO T100; ASTM D854</p>
                      </div>
                    </div>
                    <div className="test-item">
                      <span className="test-number">45.</span>
                      <div className="test-details">
                        <strong>Xác định độ ẩm và độ hút ẩm</strong>
                        <p>Tiêu chuẩn: TCVN 4196:2012; ASTM D2216; AASHTO T265</p>
                      </div>
                    </div>
                    <div className="test-item">
                      <span className="test-number">46.</span>
                      <div className="test-details">
                        <strong>Xác định giới hạn dẻo, giới hạn chảy</strong>
                        <p>Tiêu chuẩn: TCVN 4197:2012; AASHTO T89, T90; ASTM D4318</p>
                      </div>
                    </div>
                    <div className="test-item">
                      <span className="test-number">47.</span>
                      <div className="test-details">
                        <strong>Xác định thành phần cỡ hạt</strong>
                        <p>Tiêu chuẩn: TCVN 4198:2014; AASHTO T88, T27; ASTM C136, D421, D422</p>
                      </div>
                    </div>
                    <div className="test-item">
                      <span className="test-number">48.</span>
                      <div className="test-details">
                        <strong>Xác định sức chống cắt trên máy cắt phẳng</strong>
                        <p>Tiêu chuẩn: TCVN 4199:2012; ASTM D3080, 3090; AASHTO T236</p>
                      </div>
                    </div>
                    <div className="test-item">
                      <span className="test-number">49.</span>
                      <div className="test-details">
                        <strong>Xác định tính nén lún trong điều kiện không nở hông</strong>
                        <p>Tiêu chuẩn: TCVN 4200:2012; ASTM D2435; AASHTO T216</p>
                      </div>
                    </div>
                    <div className="test-item">
                      <span className="test-number">50.</span>
                      <div className="test-details">
                        <strong>Xác định độ chặt tiêu chuẩn</strong>
                        <p>Tiêu chuẩn: TCVN 4201:2012; TCVN 12790:2020; 22TCN 333:06</p>
                      </div>
                    </div>
                    <div className="test-item">
                      <span className="test-number">51.</span>
                      <div className="test-details">
                        <strong>Xác định khối lượng thể tích</strong>
                        <p>Tiêu chuẩn: TCVN 4202:2012; ASTM D2937; AASHTO T204</p>
                      </div>
                    </div>
                    <div className="test-item">
                      <span className="test-number">52.</span>
                      <div className="test-details">
                        <strong>Thí nghiệm sức chịu tải của đất (CBR) - Trong phòng thí nghiệm</strong>
                        <p>Tiêu chuẩn: 22TCN 332-06; TCVN 12792:2020; AASHTO T193; ASTM D1883</p>
                      </div>
                    </div>
                    <div className="test-item">
                      <span className="test-number">53.</span>
                      <div className="test-details">
                        <strong>Xác định độ bền nén của đất trong điều kiện có nở hông</strong>
                        <p>Tiêu chuẩn: TCVN 9438:2012; ASTM D 2166:2016; BS 1377-7:1990</p>
                      </div>
                    </div>
                    <div className="test-item">
                      <span className="test-number">54.</span>
                      <div className="test-details">
                        <strong>Xác định hệ số thấm K của đất</strong>
                        <p>Tiêu chuẩn: TCVN 8723:2012; ASTM D2434, D4511; AASHTO T49, T215</p>
                      </div>
                    </div>
                    <div className="test-item">
                      <span className="test-number">55.</span>
                      <div className="test-details">
                        <strong>Xác định đặc trưng trương nở của đất trong phòng thí nghiệm</strong>
                        <p>Tiêu chuẩn: TCVN 8719:2012; ASTM D4546:2014</p>
                      </div>
                    </div>
                    <div className="test-item">
                      <span className="test-number">56.</span>
                      <div className="test-details">
                        <strong>Xác định khối lượng thể tích khô nhỏ nhất và lớn nhất của đất rời</strong>
                        <p>Tiêu chuẩn: TCVN 8721:2012</p>
                      </div>
                    </div>
                    <div className="test-item">
                      <span className="test-number">57.</span>
                      <div className="test-details">
                        <strong>Đầm nén Proctor</strong>
                        <p>Tiêu chuẩn: TCVN 12790:2020</p>
                      </div>
                    </div>
                    <div className="test-item">
                      <span className="test-number">58.</span>
                      <div className="test-details">
                        <strong>Xác định góc nghỉ tự nhiên của đất rời</strong>
                        <p>Tiêu chuẩn: TCVN 8724:2012</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="capability-section">
                  <h4>🪨 VIII. Cơ lý đá xây dựng trong phòng (2 chỉ tiêu)</h4>
                  <div className="test-list">
                    <div className="test-item">
                      <span className="test-number">59.</span>
                      <div className="test-details">
                        <strong>Phương pháp xác định độ bền nén một trục trong phòng thí nghiệm</strong>
                        <p>Tiêu chuẩn: TCVN 10324:2014; ASTM D2938</p>
                      </div>
                    </div>
                    <div className="test-item">
                      <span className="test-number">60.</span>
                      <div className="test-details">
                        <strong>Phương pháp xác định độ ẩm, độ hút nước trong phòng thí nghiệm</strong>
                        <p>Tiêu chuẩn: TCVN 10321:2014</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="capability-section">
                  <h4>🔬 IX. Thử nghiệm tại hiện trường (9 chỉ tiêu)</h4>
                  <div className="test-list">
                    <div className="test-item">
                      <span className="test-number">61.</span>
                      <div className="test-details">
                        <strong>Xác định dung trọng, độ ẩm của đất, cát bằng phương pháp dao đai</strong>
                        <p>Tiêu chuẩn: TCVN 12791:2020</p>
                      </div>
                    </div>
                    <div className="test-item">
                      <span className="test-number">62.</span>
                      <div className="test-details">
                        <strong>Xác định độ ẩm; Khối lượng thể tích của đất trong lớp kết cấu bằng phương pháp rót cát</strong>
                        <p>Tiêu chuẩn: AASHTO T191; 22TCN 346-06</p>
                      </div>
                    </div>
                    <div className="test-item">
                      <span className="test-number">63.</span>
                      <div className="test-details">
                        <strong>Xác định modul đàn hồi "E" nền đường bằng tấm ép cứng</strong>
                        <p>Tiêu chuẩn: TCVN 8861:2011; ASTM D1195, D1194; AASHTO T221, T222, T235</p>
                      </div>
                    </div>
                    <div className="test-item">
                      <span className="test-number">64.</span>
                      <div className="test-details">
                        <strong>Xác định môđun đàn hồi "E" chung của áo đường bằng Cần đo võng Benkelman</strong>
                        <p>Tiêu chuẩn: TCVN 8867:2011</p>
                      </div>
                    </div>
                    <div className="test-item">
                      <span className="test-number">65.</span>
                      <div className="test-details">
                        <strong>Kiểm tra độ nhám mặt đường bằng phương pháp rắc cát</strong>
                        <p>Tiêu chuẩn: TCVN 8866:2011</p>
                      </div>
                    </div>
                    <div className="test-item">
                      <span className="test-number">66.</span>
                      <div className="test-details">
                        <strong>Độ bằng phẳng của mặt đường bằng thước 3m</strong>
                        <p>Tiêu chuẩn: TCVN 8864:2011</p>
                      </div>
                    </div>
                    <div className="test-item">
                      <span className="test-number">67.</span>
                      <div className="test-details">
                        <strong>Phương pháp xác định mô đun biến dạng hiện trường bằng tấm ép phẳng</strong>
                        <p>Tiêu chuẩn: TCVN 9354:2012</p>
                      </div>
                    </div>
                    <div className="test-item">
                      <span className="test-number">68.</span>
                      <div className="test-details">
                        <strong>Bê tông nặng - Phương pháp thử không phá hủy - Xác định cường độ nén sử dụng kết hợp máy đo siêu âm và súng bật nẩy</strong>
                        <p>Tiêu chuẩn: TCVN 9335:2012</p>
                      </div>
                    </div>
                    <div className="test-item">
                      <span className="test-number">69.</span>
                      <div className="test-details">
                        <strong>Thí nghiệm xuyên tiêu chuẩn (SPT)</strong>
                        <p>Tiêu chuẩn: TCVN 9351:2022</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="capability-section">
                  <h4>🛣️ X. Nhựa bitum (8 chỉ tiêu)</h4>
                  <div className="test-list">
                    <div className="test-item">
                      <span className="test-number">70.</span>
                      <div className="test-details">
                        <strong>Xác định độ kim lún</strong>
                        <p>Tiêu chuẩn: TCVN 7495:2005</p>
                      </div>
                    </div>
                    <div className="test-item">
                      <span className="test-number">71.</span>
                      <div className="test-details">
                        <strong>Xác định độ kéo dài</strong>
                        <p>Tiêu chuẩn: TCVN 7496:2005</p>
                      </div>
                    </div>
                    <div className="test-item">
                      <span className="test-number">72.</span>
                      <div className="test-details">
                        <strong>Xác định nhiệt độ hóa mềm (Phương pháp vòng và bi)</strong>
                        <p>Tiêu chuẩn: TCVN 7497:2005</p>
                      </div>
                    </div>
                    <div className="test-item">
                      <span className="test-number">73.</span>
                      <div className="test-details">
                        <strong>Xác định nhiệt độ bắt lửa</strong>
                        <p>Tiêu chuẩn: TCVN 7498:2005</p>
                      </div>
                    </div>
                    <div className="test-item">
                      <span className="test-number">74.</span>
                      <div className="test-details">
                        <strong>Xác định tổn thất khối lượng sau gia nhiệt</strong>
                        <p>Tiêu chuẩn: TCVN 7499:2005</p>
                      </div>
                    </div>
                    <div className="test-item">
                      <span className="test-number">75.</span>
                      <div className="test-details">
                        <strong>Xác định lượng hòa tan của nhựa trong tricloretylen</strong>
                        <p>Tiêu chuẩn: TCVN 7500:2005</p>
                      </div>
                    </div>
                    <div className="test-item">
                      <span className="test-number">76.</span>
                      <div className="test-details">
                        <strong>Xác định khối lượng riêng</strong>
                        <p>Tiêu chuẩn: TCVN 7501:2005</p>
                      </div>
                    </div>
                    <div className="test-item">
                      <span className="test-number">77.</span>
                      <div className="test-details">
                        <strong>Xác định độ dính bám với đá</strong>
                        <p>Tiêu chuẩn: TCVN 7504:2005</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="capability-section">
                  <h4>🛤️ XI. Bê tông nhựa (20 chỉ tiêu)</h4>
                  <div className="test-list">
                    <div className="test-item">
                      <span className="test-number">78.</span>
                      <div className="test-details">
                        <strong>Xác định độ ổn định, độ dẻo Marshall</strong>
                        <p>Tiêu chuẩn: TCVN 8860-1:2011</p>
                      </div>
                    </div>
                    <div className="test-item">
                      <span className="test-number">79.</span>
                      <div className="test-details">
                        <strong>Xác định hàm lượng nhựa bằng phương pháp chiết sử dụng máy ly tâm</strong>
                        <p>Tiêu chuẩn: TCVN 8860-2:2011</p>
                      </div>
                    </div>
                    <div className="test-item">
                      <span className="test-number">80.</span>
                      <div className="test-details">
                        <strong>Xác định thành phần hạt</strong>
                        <p>Tiêu chuẩn: TCVN 8860-3:2011</p>
                      </div>
                    </div>
                    <div className="test-item">
                      <span className="test-number">81.</span>
                      <div className="test-details">
                        <strong>Xác định tỷ trọng lớn nhất, khối lượng riêng của bê tông nhựa ở trạng thái rời</strong>
                        <p>Tiêu chuẩn: TCVN 8860-4:2011</p>
                      </div>
                    </div>
                    <div className="test-item">
                      <span className="test-number">82.</span>
                      <div className="test-details">
                        <strong>Xác định tỷ trọng lớn nhất, khối lượng riêng của bê tông nhựa ở trạng thái đầm nén</strong>
                        <p>Tiêu chuẩn: TCVN 8860-5:2011</p>
                      </div>
                    </div>
                    <div className="test-item">
                      <span className="test-number">83.</span>
                      <div className="test-details">
                        <strong>Xác định độ chảy nhựa</strong>
                        <p>Tiêu chuẩn: TCVN 8860-6:2011</p>
                      </div>
                    </div>
                    <div className="test-item">
                      <span className="test-number">84.</span>
                      <div className="test-details">
                        <strong>Xác định độ góc cạnh của cát</strong>
                        <p>Tiêu chuẩn: TCVN 8860-7:2011</p>
                      </div>
                    </div>
                    <div className="test-item">
                      <span className="test-number">85.</span>
                      <div className="test-details">
                        <strong>Xác định hệ số độ chặt lu lèn</strong>
                        <p>Tiêu chuẩn: TCVN 8860-8:2011</p>
                      </div>
                    </div>
                    <div className="test-item">
                      <span className="test-number">86.</span>
                      <div className="test-details">
                        <strong>Xác định độ rỗng dư</strong>
                        <p>Tiêu chuẩn: TCVN 8860-9:2011</p>
                      </div>
                    </div>
                    <div className="test-item">
                      <span className="test-number">87.</span>
                      <div className="test-details">
                        <strong>Xác định độ rỗng cốt liệu</strong>
                        <p>Tiêu chuẩn: TCVN 8860-10:2011</p>
                      </div>
                    </div>
                    <div className="test-item">
                      <span className="test-number">88.</span>
                      <div className="test-details">
                        <strong>Xác định độ rỗng lấp đầy nhựa</strong>
                        <p>Tiêu chuẩn: TCVN 8860-11:2011</p>
                      </div>
                    </div>
                    <div className="test-item">
                      <span className="test-number">89.</span>
                      <div className="test-details">
                        <strong>Xác định độ ổn định còn lại của bê tông nhựa</strong>
                        <p>Tiêu chuẩn: TCVN 8860-12:2011</p>
                      </div>
                    </div>
                    <div className="test-item">
                      <span className="test-number">90.</span>
                      <div className="test-details">
                        <strong>Thiết kế hỗn hợp bê tông nhựa nóng theo phương pháp Marshall</strong>
                        <p>Tiêu chuẩn: TCVN 8820:2021</p>
                      </div>
                    </div>
                    <div className="test-item">
                      <span className="test-number">91.</span>
                      <div className="test-details">
                        <strong>Xác định thành phần hạt; Xác định hàm lượng nước; Xác định khối lượng riêng của bột khoáng chất</strong>
                        <p>Tiêu chuẩn: 22TCN 58-84; TCVN 12884-2:2020</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="capability-section">
                  <h4>💧 XII. Phân tích hóa nước cho xây dựng (5 chỉ tiêu)</h4>
                  <div className="test-list">
                    <div className="test-item">
                      <span className="test-number">92.</span>
                      <div className="test-details">
                        <strong>Xác định hàm lượng cặn không tan, hàm lượng muối hòa tan</strong>
                        <p>Tiêu chuẩn: TCVN 4560:2012</p>
                      </div>
                    </div>
                    <div className="test-item">
                      <span className="test-number">93.</span>
                      <div className="test-details">
                        <strong>Xác định độ pH</strong>
                        <p>Tiêu chuẩn: TCVN 6492:2011; ISO 10523:2008</p>
                      </div>
                    </div>
                    <div className="test-item">
                      <span className="test-number">94.</span>
                      <div className="test-details">
                        <strong>Xác định hàm lượng ion clorua (Cl⁻)</strong>
                        <p>Tiêu chuẩn: TCVN 6194:1996; ISO 9297:1989</p>
                      </div>
                    </div>
                    <div className="test-item">
                      <span className="test-number">95.</span>
                      <div className="test-details">
                        <strong>Xác định hàm lượng ion Sunfat (SO₄²⁻)</strong>
                        <p>Tiêu chuẩn: TCVN 6200:1996; ISO 9280:1990</p>
                      </div>
                    </div>
                    <div className="test-item">
                      <span className="test-number">96.</span>
                      <div className="test-details">
                        <strong>Xác định tạp chất hữu cơ</strong>
                        <p>Tiêu chuẩn: TCVN 6186:1996</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="capability-section">
                  <h4>🧪 XIII. Phụ gia cho bê tông và vữa (1 chỉ tiêu)</h4>
                  <div className="test-list">
                    <div className="test-item">
                      <span className="test-number">102.</span>
                      <div className="test-details">
                        <strong>Phụ gia hóa học cho bê tông xác định: lượng nước trộn tối đa, thời gian đông kết chênh lệch và cường độ nén so với mẫu đối chứng</strong>
                        <p>Tiêu chuẩn: TCVN 8826:2024</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="lab-staff">
              <h3>Đội ngũ kỹ thuật viên:</h3>
              <div className="staff-info">
                <p><strong>Kỹ thuật viên chính:</strong> Lê Thị Tuyến, Lê Thị Thu Phương, Phạm Văn Sơn, Nguyễn Anh Hùng, Trần Quý Phong, Trần Thị Thu Hà</p>
                <p><strong>Chuyên môn:</strong> Được đào tạo chuyên sâu về các tiêu chuẩn TCVN, ASTM, AASHTO</p>
              </div>
            </div>
            
            <div className="equipment-cta">
              <a href="/equipment" className="btn btn-primary">Xem chi tiết thiết bị thí nghiệm</a>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Services;